/* <faq-page> — SSS kategori sekmeleri + istemci tarafı arama (eşleşme vurgusu, sonuç yok durumu) */
class FaqPage extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[data-faq-panel]'));
    this.items = Array.from(this.querySelectorAll('[data-faq-item]')).map((el) => {
      const q = el.querySelector('[data-faq-q]');
      const a = el.querySelector('[data-faq-a]');
      return {
        el,
        q,
        a,
        qHTML: q.innerHTML,
        aHTML: a.innerHTML,
        qText: this.norm(q.textContent),
        aText: this.norm(a.textContent),
      };
    });
    this.input = this.querySelector('[data-faq-search]');
    this.status = this.querySelector('[data-faq-status]');
    this.empty = this.querySelector('[data-faq-empty]');
    this.clearBtn = this.querySelector('[data-faq-clear-input]');

    this.tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => this.select(i));
      tab.addEventListener('keydown', (e) => this.onTabKey(e, i));
    });
    if (this.tabs.length) this.select(Math.max(0, this.tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true')), false);

    if (this.input) {
      const run = window.CPL && CPL.debounce ? CPL.debounce(() => this.search(), 150) : () => this.search();
      this.input.addEventListener('input', run);
      this.input.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.input.value) {
          e.preventDefault();
          this.clear();
        }
      });
      this.input.closest('form')?.addEventListener('submit', (e) => e.preventDefault());
    }
    this.querySelectorAll('[data-faq-clear]').forEach((b) =>
      b.addEventListener('click', () => {
        this.clear();
        this.input?.focus();
      })
    );
    this.classList.add('is-ready');
  }

  norm(s) {
    return s.replace(/\s+/g, ' ').trim().toLocaleLowerCase('tr-TR');
  }

  select(index, focus = false) {
    this.tabs.forEach((tab, i) => {
      const on = i === index;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
      const panel = document.getElementById(tab.getAttribute('aria-controls'));
      if (panel) panel.classList.toggle('is-active', on);
    });
    if (focus) this.tabs[index].focus();
  }

  onTabKey(e, i) {
    const last = this.tabs.length - 1;
    let next = null;
    if (e.key === 'ArrowRight') next = i === last ? 0 : i + 1;
    else if (e.key === 'ArrowLeft') next = i === 0 ? last : i - 1;
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = last;
    if (next === null) return;
    e.preventDefault();
    this.select(next, true);
  }

  clear() {
    if (!this.input) return;
    this.input.value = '';
    this.search();
  }

  search() {
    const q = this.norm(this.input.value);
    const searching = q.length > 0;
    this.classList.toggle('is-searching', searching);
    if (this.clearBtn) this.clearBtn.hidden = !searching;

    let count = 0;
    this.items.forEach((item) => {
      item.q.innerHTML = item.qHTML;
      item.a.innerHTML = item.aHTML;
      if (!searching) {
        item.el.hidden = false;
        return;
      }
      const inQ = item.qText.includes(q);
      const inA = item.aText.includes(q);
      const match = inQ || inA;
      item.el.hidden = !match;
      if (!match) return;
      count++;
      this.mark(item.q, q);
      this.mark(item.a, q);
      if (inA && !inQ) item.el.open = true;
    });

    this.panels.forEach((panel) => {
      panel.hidden = searching && !panel.querySelector('[data-faq-item]:not([hidden])');
    });

    if (this.empty) this.empty.hidden = !(searching && count === 0);
    if (this.status) {
      this.status.hidden = !searching;
      this.status.textContent = searching
        ? (this.status.dataset.template || '').replace('[query]', this.input.value.trim()).replace('[count]', count)
        : '';
    }
  }

  /* Metin düğümlerindeki eşleşmeleri <mark> ile sar */
  mark(root, q) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const text = node.nodeValue;
      const lower = text.toLocaleLowerCase('tr-TR');
      if (lower.length !== text.length) return;
      let idx = lower.indexOf(q);
      if (idx === -1) return;
      const frag = document.createDocumentFragment();
      let pos = 0;
      while (idx !== -1) {
        if (idx > pos) frag.append(text.slice(pos, idx));
        const m = document.createElement('mark');
        m.className = 'faq-page__mark';
        m.textContent = text.slice(idx, idx + q.length);
        frag.append(m);
        pos = idx + q.length;
        idx = lower.indexOf(q, pos);
      }
      if (pos < text.length) frag.append(text.slice(pos));
      node.replaceWith(frag);
    });
  }
}
if (!customElements.get('faq-page')) customElements.define('faq-page', FaqPage);
